import Consumer from "@app/channels/consumer";

export class BaseChannel {
  constructor({ channel: channel, params: params, attributes: attributes}) {
    this.consumer   = Consumer;
    this.channel    = channel;
    this.params     = params || {};

    Object.keys(attributes || {}).forEach((attribute) => {
      this[attribute] = attributes[attribute];
    });

    this.channelName = function () {
      return this.identifier ? JSON.parse(this.identifier)["channel"] : this.channel;
    };

    this.channelParams = function (params = {}) {
      params = JSON.parse(this.identifier);
      delete params.channel;
      return params;
    };
  }

  connected() {
    this.channel  = this.channelName();
    this.params   = this.channelParams();

    ChannelManager.activateChannel(this);
    ChannelManager.trigger("channelsLoaded");

    console.log(
      `%cWebsocket\n%c${this.channel} %cis connected ...`,
      "font-weight:bold;color:white;",
      "color:orange;",
      "color:gray;"
    );
  }

  received(payload){
    if(typeof payload == "object" && !Array.isArray(payload)){
      let actionName = this.camelize(payload.action);
      if(typeof(this[actionName]) == "function"){
        this[actionName](payload);
      }
    }
  }

  disconnect() {
    // Unsubscribe Subscription
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    ChannelManager.killChannel(this);
    ChannelManager.trigger("channelsDeactivated", [this]);

    console.log(
      `%cWebsocket\n%c${this.channel} %cis disconnected.`,
      "font-weight:bold;color:white;",
      "color:orange;",
      "color:gray;"
    );
  }

  assignSubscriptionAttributes(){
    if(!this.subscription) return;
    const defaultAttributes = ['consumer', 'channel', 'params', 'channelName', 'channelParams', 'subscription'];
    const objectAttributes  = Object.keys(this);
    const attributes        = objectAttributes.filter(attribute => !defaultAttributes.includes(attribute));
    attributes.forEach((attribute) => {
      this.subscription[attribute] = this[attribute];
    });
    return this.subscription;
  }

  camelize(str, upperFirst = false) {
    if (typeof str !== "string" || str.length === 0) return ""

    const result = str
      .trim()
      .toLowerCase()
      .replace(/[-_\s]+(.)?/g, (_, char) => (char ? char.toUpperCase() : ""))

    return upperFirst
      ? result.charAt(0).toUpperCase() + result.slice(1)
      : result
  }

  async subscribe() {
    this.subscription = await this.consumer.subscriptions.create_mod(this.#getParams(), this.#getMethods());
    this.assignSubscriptionAttributes();

    return this.subscription;
  }

  #getParams() {
    return { channel: this.channel, ...this.params };
  }

  #getMethods() {
    let methods = {},
      currentObj = this;

    while (currentObj !== null) {
      Object.getOwnPropertyNames(currentObj)
        .filter((prop) => typeof currentObj[prop] === "function")
        .forEach((prop) => {
          if (!methods.hasOwnProperty(prop)) {
            methods[prop] = currentObj[prop];
          }
        });
      currentObj = Object.getPrototypeOf(currentObj);
    }

    return methods;
  }
}
